import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00190 = new TileLayer({
  title: 'Máscara 20090923',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090923l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00190.setVisible(false);
  
const layer00189 = new TileLayer({
  title: 'Máscara 20091017',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20091017l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00189.setVisible(false);
  
const layer00188 = new TileLayer({
  title: 'Máscara 20091204',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20091204l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00188.setVisible(false);
  
const layer00187 = new TileLayer({
  title: 'Máscara 20100129',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100129l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00187.setVisible(false);
  
const layer00186 = new TileLayer({
  title: 'Máscara 20100403',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100403l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00186.setVisible(false);
  
const layer00185 = new TileLayer({
  title: 'Máscara 20100427',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100427l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00185.setVisible(false);
  
const layer00184 = new TileLayer({
  title: 'Máscara 20100505',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100505l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00184.setVisible(false);
  
const layer00183 = new TileLayer({
  title: 'Máscara 20100521',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100521l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00183.setVisible(false);
  
const layer00182 = new TileLayer({
  title: 'Máscara 20100529',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100529l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00182.setVisible(false);
  
const layer00181 = new TileLayer({
  title: 'Máscara 20100606',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100606l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00181.setVisible(false);
  
const layer00180 = new TileLayer({
  title: 'Máscara 20100622',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100622l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00180.setVisible(false);
  
const layer00179 = new TileLayer({
  title: 'Máscara 20100630',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100630l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00179.setVisible(false);
  
const layer00178 = new TileLayer({
  title: 'Máscara 20100716',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100716l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00178.setVisible(false);
  
const layer00177 = new TileLayer({
  title: 'Máscara 20100801',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100801l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00177.setVisible(false);
  
const layer00176 = new TileLayer({
  title: 'Máscara 20100825',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100825l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00176.setVisible(false);

export const grupoCapa01_12 = new LayerGroup({
  title: 'Ciclo Hidrológico 2009-2010',
  fold: 'close',
  layers: [layer00176, layer00177, layer00178, layer00179, layer00180, layer00181, layer00182, layer00183, layer00184, layer00185, layer00186, layer00187, layer00188, layer00189, layer00190]
});